import { RowHeightsUserLogs } from '../typings/grid';

class MaxHeightHelper {
    private maxHeights: Map<number, number>;

    constructor() {
        this.maxHeights = new Map<number, number>();
    }

    public clear = (): void => {
        this.maxHeights = new Map<number, number>();
    };

    public setMaxHeight = (rowIndex: number, gridMaxHeight: number): void => {
        this.maxHeights.set(rowIndex, gridMaxHeight);
    };

    public getMaxHeight = (rowIndex: number): number | undefined => {
        return this.maxHeights.get(rowIndex);
    };

    public getRowHeight = (rowIndex: number, isExpanded: boolean, canExpand: boolean): number => {
        const maxHeight = this.getMaxHeight(rowIndex);
        return isExpanded && canExpand && maxHeight ? maxHeight : RowHeightsUserLogs.default;
    };
}

export const maxHeightHelper = new MaxHeightHelper();
